<template>
    <LayoutBase>
        <div class="container">
            <h2>Your posts</h2>
            <div class="panel">
                <ListPosts></ListPosts>
            </div>
        </div>
    </LayoutBase>
</template>

<script>
    // const Uppy = require('@uppy/core');
    // const XHRUpload = require('@uppy/xhr-upload');
    // const Dashboard = require('@uppy/dashboard');
    //const Url = require('@uppy/url');
    // const MediaLibrary = require('../../../lib/MediaLibrary');

    import LayoutBase from '../../layouts/LayoutBase';
    import ListPosts from "../../list/ListPosts";
    import { mapState, mapGetters } from 'vuex';

    export default {
        components: {
            LayoutBase,
            ListPosts
        },
        data () {
            return {}
        },
        computed: {
            ...mapState({
                loggedInUser: state => state.auth.user,
            })
        },
        created() {
        },
        mounted() {

        },
        methods: {
        }
    }
</script>
